module.exports = __webpack_public_path__ + "img/image_part_003.071fe1e3.jpg";